import styles from './NotificationDropDown.module.scss';
import moment from 'moment';
import { getInitialsFromName } from '../../../utils/miscUtils';

export default function NotificationItem({ item }: any) {
  const lang = localStorage.getItem('lang') || 'en';
  return (
    <div className={styles.item}>
      <div className={`${styles.avatar} ${styles.blue}`}>
        {getInitialsFromName(`${item?.triggered_by}`) || 'CC'}
      </div>
      <div>
        <p className={styles.title}>{item.title}</p>
        <p className={styles.description}>{item.body}</p>
      </div>
      <span className={styles.date}>
        {moment(item?.datetime_create).locale(lang).fromNow()}
        {item.read !== true && <div className={styles.dot} />}
      </span>
    </div>
  );
}
